// extracted by mini-css-extract-plugin
export default {"fieldsWrapper":"UrlProcessor_fieldsWrapper__r5vHs"};